import React from 'react'
import NameCSS from './name.module.css'

const Name = ({ cat }) => (
  <div className={[NameCSS.boxname, cat, 'boxname'].join(' ')}>{cat}</div>
)

export default Name
